module.exports = __webpack_public_path__ + "static/media/14UNEP6.ae14a9d6.jpg";